import React from 'react';
import PropTypes from 'prop-types';

import IndependentReviewVideo from './independentReviewVideo';
import IndependentReviewContent from './independentReviewContent';

const IndependentReview = ({
  images,
  manufacturer,
  model,
  reviewContentMarkup,
  scores,
  videoUrl,
}) => {
  return (
    <div className="ch-row" data-element="independent-review">
      <div className="sm:ch-col--6">
        <h3 className="ac-independent-review__heading">Independent review</h3>
      </div>

      <div className="sm:ch-col--6">
        <p className="ac-independent-review__provider">
          Review courtesy of Car and Driving
        </p>
      </div>

      <div className="sm:ch-col--8">
        {videoUrl && (
          <IndependentReviewVideo
            placeholderImage={images.large[0]}
            videoUrl={videoUrl}
          />
        )}
        {reviewContentMarkup && (
          <>
            <h3>
              {manufacturer} {model}
            </h3>
            <IndependentReviewContent
              reviewContentMarkup={reviewContentMarkup}
            />
          </>
        )}
      </div>

      <div className="sm:ch-col--4">
        <div className="ch-mv--4 sm:ch-mv--0">
          <div className="ch-grid ch-grid-cols--2 ch-gap--2">
            {images.small.map((image) => (
              <img
                alt=""
                className="ch-img--responsive"
                key={image}
                loading="lazy"
                src={image}
              />
            ))}
          </div>
        </div>
        {scores && (
          <dl className="ac-independent-review__scores">
            {Object.keys(scores).map((score) => {
              return (
                <React.Fragment key={score}>
                  <dt className="ac-independent-review__score-category">
                    {score}
                  </dt>
                  <dd className="ac-independent-review__score">
                    {scores[score]}
                  </dd>
                  <dd className="ac-independent-review__score-bar">
                    <span
                      style={{
                        width: scores[score],
                      }}
                    />
                  </dd>
                </React.Fragment>
              );
            })}
          </dl>
        )}
      </div>
    </div>
  );
};

export default IndependentReview;

IndependentReview.propTypes = {
  images: PropTypes.object,
  manufacturer: PropTypes.string,
  model: PropTypes.string,
  reviewContentMarkup: PropTypes.string,
  scores: PropTypes.object,
  videoUrl: PropTypes.string,
};
